import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { Link } from 'react-router-dom';
import { ModelOfCategory } from 'src/database';
import LoadingScreen from '../../components/LoadingScreen';
import { useListCategoriesController, } from '../../controllers/Category/ListCategoriesController';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';

const CategoriesList: React.FC = () => {
    const { getCategoryListController, handleCategoryListController } = useListCategoriesController();

    if (getCategoryListController.loading) {
        return <LoadingScreen />
    };

    const actionBodyTemplate = (category: ModelOfCategory) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => handleCategoryListController.openEditDialog(category)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleCategoryListController.openDeleteDialog(category)} />
            </React.Fragment>
        );
    };

    const editCategoryDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleCategoryListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getCategoryListController.formik.handleSubmit() }} />
        </React.Fragment>
    );

    const deleteCategoryDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleCategoryListController.closeDeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getCategoryListController.selectedCategory && handleCategoryListController.removeCategory(getCategoryListController.selectedCategory)
                }}
            />
        </React.Fragment>
    );

    const leftCategoryToolbar = () => {
        return (
            <Link to="/categoryForm">
                <Button label="Cadastrar categoria" icon="pi pi-plus" className="p-button-success p-mr-2" />
            </Link>
        );
    };

    return (
        <div>
            <Toast ref={getCategoryListController.toast} />
            <div className="p-card p-p-4 datatable-container">
                <Toolbar className="p-mb-4" left={leftCategoryToolbar}></Toolbar>

                <DataTable className="p-datatable-sm"
                    dataKey="ID" rowHover scrollable scrollHeight={'100%'}
                    value={getCategoryListController.categoriesData}>
                    <Column field="DESCRICAO" header="Categoria"></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
            </div>

            <Dialog
                className="p-fluid"
                style={{ width: '450px' }}
                visible={getCategoryListController.editDialog}
                onHide={handleCategoryListController.closeEditDialog}
                onShow={() => getCategoryListController.formik.setFieldValue('DESCRICAO', getCategoryListController.selectedCategory?.DESCRICAO)}
                footer={editCategoryDialogFooter}
                header={`Editar categoria ${getCategoryListController.selectedCategory?.DESCRICAO}`}
                modal
            >
                <div className="p-field">
                    <label htmlFor="description">Nome</label>
                    <InputText id="name" type="text" maxLength={150}
                        value={getCategoryListController.formik.values.DESCRICAO}
                        onChange={getCategoryListController.formik.handleChange('DESCRICAO')}
                        required
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getCategoryListController.formik.touched.DESCRICAO && getCategoryListController.formik.errors.DESCRICAO,
                        'popup-form-inactive': !(getCategoryListController.formik.touched.DESCRICAO && getCategoryListController.formik.errors.DESCRICAO),
                    })}
                    >{getCategoryListController.formik.errors.DESCRICAO}</div>
                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getCategoryListController.deleteDialog}
                onHide={handleCategoryListController.closeDeleteDialog}
                footer={deleteCategoryDialogFooter}
                header="Remover categoria"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getCategoryListController.selectedCategory && <span>Você tem certeza que deseja deletar a categoria <b>{getCategoryListController.selectedCategory.DESCRICAO}</b>?</span>}
                </div>
            </Dialog>
        </div>

    );
};

export default CategoriesList;